import { Anchor, Breadcrumbs, Text } from '@mantine/core';
import queryString from 'query-string';
import { useLocation, useNavigate, useParams } from 'react-router';
import StoriesNewForm from '../../components/Stories/StoriesNewForm';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';

const StoriesNewPage = () => {
  const pageTitle = `${Page.stories}`;
  const navigate = useNavigate();
  const location = useLocation();
  const { accountId, domainId } = useParams();
  const { from } = queryString.parse(location.search);

  return (
    <>
      <Metadata title={`${pageTitle} | New`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/stories`}>Stories</Anchor>
        <Text>New</Text>
      </Breadcrumbs>

      <StoriesNewForm
        from={from}
        onSuccess={() => navigate(`/accounts/${accountId}/domains/${domainId}/stories`)}
        onBack={() => navigate(`/accounts/${accountId}/domains/${domainId}/stories`)}
      />
    </>
  );
};

export default StoriesNewPage;
